import React from 'react';
import { cn } from '@/utils/cn';
import EnterpriseFeatureCard from '@/components/common/Card/EnterpriseFeatureCard';

interface FeatureItem {
  icon: string;
  title: string;
  description: string;
  bulletPoints: {
    icon: string;
    text: string;
  }[];
}

interface EnterpriseFeaturesProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  subtitle: string;
  features: FeatureItem[];
}

const EnterpriseFeatures = ({
  className,
  title = "Powering the Enterprise Future",
  subtitle = "Explore the breakthrough capabilities behind Cobalt MCP",
  features,
  ...props
}: EnterpriseFeaturesProps) => {
  return (
    <section className={cn("py-12 md:py-20 px-4 bg-black text-white", className)} {...props}>
      <div className="container mx-auto max-w-7xl">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-bold mb-3">{title}</h2>
          <p className="text-base text-gray-400 max-w-2xl mx-auto">{subtitle}</p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div className="flex justify-center md:block" key={index}>
              <EnterpriseFeatureCard
                icon={feature.icon}
                title={feature.title}
                description={feature.description}
                bulletPoints={feature.bulletPoints}
                className="w-full max-w-sm md:max-w-none"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EnterpriseFeatures;